// extracted by mini-css-extract-plugin
module.exports = {"testimonialGroup":"testimonials-module--testimonial-group--1eya3","testimonials":"testimonials-module--testimonials--jrs3a","testimonial":"testimonials-module--testimonial--doRcX"};